export default "__VITE_ASSET__CmXUHx99__"